module.exports = __webpack_public_path__ + "static/media/mli_logo.527b4031.svg";